import { nextTick, reactive } from 'vue'
import { CredentialsException, ErrorException } from '@/utils/exceptions'

type iDataRequest = {
  pending: boolean
  success: boolean
}

const useDataRequest = () => {
  type iFailOptions = {
    message?: string
    showMessage: boolean
  }

  const state = reactive<iDataRequest>({
    pending: false,
    success: false
  })

  return {
    state,

    start () {
      state.pending = true
      state.success = false
    },
    end () {
      state.pending = false
    },
    success () {
      state.success = true
      state.pending = false
    },
    fail (options: iFailOptions = {} as iFailOptions) {
      state.pending = false
      if (options.showMessage && options.message) {
        alert(options.message)
      }
    },
    async tryRequest (callback: () => void): Promise<boolean> {
      try {
        this.start()
        await nextTick(callback)
        this.success()
        return true
      } catch (e: unknown) {
        if (e instanceof CredentialsException) {
          this.fail({ message: 'Необходима авторизация', showMessage: true })
        } else if (e instanceof ErrorException) {
          if (e.code >= 500) {
            this.fail({ message: 'Серверная ошибка', showMessage: true })
          } else {
            switch (e.code) {
              case 403:
                this.fail({ message: 'Действие запрещено', showMessage: true })
                break
              case 404:
                this.fail({ message: 'Объект не найден', showMessage: true })
                break
              default:
                this.fail({ message: 'Неправильные данные', showMessage: true })
            }
          }
        } else {
          this.fail({ message: 'Неизвестная ошибка', showMessage: true })
        }

        return false
      }
    }
  }
}

export default useDataRequest
